import type { ParkingRateType } from "./payment-zone-area.type";

export enum RateTypeEnum {
  SHORT = "short",
  LONG = "long",
}

export enum AnchorUnitEnum {
  MIN = "min",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
}

export type PricingAnchor = {
  id?: string;
  duration: number;
  unit?: AnchorUnitEnum;
  priceAmount: number;
  isShortcut?: boolean;
};

export enum GenerationModeEnum {
  NONE = "none",
  TIME_STEP = "time-step",
  PRICE_STEP = "price-step",
}

export enum RoundModeEnum {
  NEAREST = "nearest",
  UP = "up",
  DOWN = "down",
}

export type RoundingOptions = {
  roundTo: number;
  roundMode: RoundModeEnum;
  keepAnchorsExact: boolean;
};

export type PricingPoint = {
  duration: number;
  priceAmount: number;
  isAnchor: boolean;
};

export type PricingConfiguration = {
  anchors?: PricingAnchor[];
  generationMode: {
    mode: GenerationModeEnum;
    stepValue?: number;
  };
  roundingRules: RoundingOptions;
};

export type GeneratedPricing = {
  points: PricingPoint[];
  warnings: string[];
};

export type PricingConfiguratorState = {
  anchors: PricingAnchor[];
  generationMode: GenerationModeEnum;
  timeStep: number;
  priceStep: number;
  roundTo: number;
  roundMode: RoundModeEnum;
  keepAnchorsExact: boolean;
};
export type GenerationModeOption = {
  value: GenerationModeEnum;
  title: string;
  description: string;
};

export type GroupedRate = {
  logicalRateId: string;
  currentRate: ParkingRateType;
  allVersions: ParkingRateType[];
  currentVersions: ParkingRateType[];
  previousVersions: ParkingRateType[];
};
